(function () {
    'use strict';
    /*
     * Copyright (c) 2014 In Hand Health.
     * All rights reserved.
     */

    /**
     * The controller for choosing a file.
     */
    angular
        .module('ihh-common-web')
        .controller('IhhFileChooserCtrl', IhhFileChooserCtrl);

    IhhFileChooserCtrl.$inject = ['$scope', '$modalInstance', '$q', '$timeout', 'Cropper', 'config'];

    function IhhFileChooserCtrl($scope, $modalInstance, $q, $timeout, Cropper, config) {
        config = config || {};
        var file, data;

        var fileTypes = {
            video: '.mp4, .mov',
            audio: '.mp3, .m4a, .aac',
            image: '.jpeg, .jpg, .gif, .png',
            thumbnail: '.jpeg, .jpg, .gif, .png',
            pdf: '.pdf',
            stl: '.stl',
            csv: '.csv'
        };

        $scope.title = config.title;
        $scope.message = config.message;

        $scope.mediaType = config.mediaType || 'unknown';

        $scope.fileType = fileTypes[config.mediaType];

        $scope.badFile = false;

        $scope.ok = function(pickedFile) {
            if ($scope.mediaType === 'image' || $scope.mediaType === 'thumbnail') {
                $scope.preview().then(function() {
                    var binary = atob($scope.preview.dataUrl.split(',')[1]);
                    var array = [];
                    for (var i = 0; i < binary.length; i++) {
                        array.push(binary.charCodeAt(i));
                    }
                    var contentTypeStart = $scope.preview.dataUrl.indexOf('data:') + 'data:'.length;
                    var contentTypeEnd = $scope.preview.dataUrl.indexOf(';');
                    var mediaTypeExt = $scope.preview.dataUrl.slice(contentTypeStart, contentTypeEnd);
                    var imgBlob = new Blob([new Uint8Array(array)], {
                        type: mediaTypeExt
                    });
                    // transferring the members of File which are not natively in Blob
                    imgBlob.name = pickedFile.name;
                    imgBlob.lastModified = pickedFile.lastModified;
                    imgBlob.lastModifiedDate = pickedFile.lastModifiedDate;
                    imgBlob.webkitRelativePath = pickedFile.webkitRelativePath;
                    $modalInstance.close(imgBlob);
                });
            }
            else {
                $modalInstance.close(pickedFile);
            }
        };

        /**
         * Checks the file's type to ensure it matches the allowed types.
         *
         * @param {Object} file - the file to upload
         * @param {String} expectedFileType - the expected file type
         * @returns {promise} a promise which resolves if the file has the correct extension or doesn't exist
         */
        function checkFileType(file, expectedFileType) {
            var defer = $q.defer();
            var hasCorrectExtension = false;
            var fileExists = angular.isDefined(file && file !== null);

            if (fileExists) {
                // check the extension
                var filenameArr = file.name.split('.');
                var fileExtension = '.' + (filenameArr[filenameArr.length - 1]).toLowerCase();
                var expectedFileExtensions = expectedFileType.split(', ');
                for (var i = 0; i < expectedFileExtensions.length; i++) {
                    if (expectedFileExtensions[i] === fileExtension) {
                        hasCorrectExtension = true;
                        break;
                    }
                }
            }

            if (hasCorrectExtension || !fileExists) {
                defer.resolve();
            }
            else {
                defer.reject();
            }

            return defer.promise;
        }

        /**
         * Method is called every time file input's value changes.
         * Because of Angular has not ng-change for file inputs a hack is needed -
         * call `angular.element(this).scope().onFile(this.files[0])`
         * when input's event is fired.
         *
         * @param {object} blob - the file in blob form
         */
        $scope.onFile = function(blob) {
            checkFileType(blob, $scope.fileType).then(function() {
                $scope.badFile = false;
                if ($scope.mediaType === 'image' || $scope.mediaType === 'thumbnail') {
                    Cropper.encode((file = blob)).then(function(dataUrl) {
                        $scope.dataUrl = dataUrl;
                        $timeout(showCropper); // wait for $digest to set image's src
                    });
                }
            }, function() {
                $scope.badFile = true;
            });
        };

        /**
         * Croppers container object should be created in controller's scope
         * for updates by directive via prototypal inheritance.
         * Pass a full proxy name to the `ng-cropper-proxy` directive attribute to
         * enable proxing.
         */
        $scope.cropper = {};
        $scope.cropperProxy = 'cropper.proxyFn';

        /**
         * Object is used to pass options to initalize a cropper.
         * More on options - https://github.com/fengyuanchen/cropper#options
         */
        $scope.options = {
            viewMode: 2,
            maximize: true,
            aspectRatio: config.aspectRatio,
            crop: function(dataNew) {
                data = dataNew;
            },
            cropend: function() {
                $scope.preview();
            }
        };

        /**
         * Showing (initializing) and hiding (destroying) of a cropper are started by
         * events. The scope of the `ng-cropper` directive is derived from the scope of
         * the controller. When initializing the `ng-cropper` directive adds two handlers
         * listening to events passed by `ng-cropper-show` & `ng-cropper-hide` attributes.
         * To show or hide a cropper `$broadcast` a proper event.
         */
        $scope.showEvent = 'show';
        $scope.hideEvent = 'hide';

        function showCropper() {
            $scope.$broadcast($scope.showEvent);
        }

        $scope.showPreview = false;

        $scope.togglePreview = function() {
            $scope.showPreview = !$scope.showPreview;
            if ($scope.showPreview) {
                $scope.preview();
            }
        };

        /**
         * When there is a cropped image to show encode it to base64 string and
         * use as a source for an image element.
         */
        $scope.preview = function() {
            var defer = $q.defer();
            if (!file || !data) {
                defer.resolve();
                return defer.promise;
            }
            Cropper.crop(file, data).then(Cropper.encode).then(function(dataUrl) {
                if (data.rotate === 0) {
                    ($scope.preview || ($scope.preview = {})).dataUrl = dataUrl;
                }
                else {
                    ($scope.preview || ($scope.preview = {})).dataUrl = $scope.cropper.proxyFn('getCroppedCanvas', data).toDataURL();
                }
                defer.resolve();
            });
            return defer.promise;
        };

        $scope.rotate = function() {
            $scope.cropper.proxyFn('rotate', 90);
        };

        /**
         * @function ChooseThumbnailCtrl#cancel
         * @description Cancels the choose thumbnail and goes back.
         */
        $scope.cancel = function() {
            $modalInstance.dismiss('cancel');
        };
    }
})();